// based on rc-rate 2.5.0
import Rate from './src/';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-rate/index.js
// module id = null
// module chunks = 